import "./TextEditorDeleteAction.scss"

export default function TextEditorDeleteAction(
    {
        priority,
        value = [],
        setValue
    }
) {


    function handleDeleteItem() {
        const _value = value
        setValue([])

        _value.map((item, index) => {
            if (item.priority !== priority) {
                setValue(prev => [
                    ...prev,
                    {
                        ...item,
                        priority: index
                    }
                ])
            }
        })
    }

    return (
        <div className={"editorDeleteActionBaseContainer"} onClick={handleDeleteItem}>
            <div className={"icTrash seeMoreContainer"}/>
        </div>
    )
}